// Injects the Tauri `get_keyboard_layout` IPC lookup into @heidi/dictate's
// keyboard-ports seam (SCR-7069). Imported for effect in `_app.tsx`. The web
// path reads `navigator.keyboard.getLayoutMap()` directly and never hits the
// port.
import { systemController } from '@/tauri/controller/system';
import { configureDictationKeyboardPorts } from '@heidi/dictate';

configureDictationKeyboardPorts({
  getKeyboardLayout: () => systemController.get_keyboard_layout(),
});
